import { render, staticRenderFns } from "./SelectorAsientoComponent.vue?vue&type=template&id=623d6f5c&scoped=true"
import script from "./SelectorAsientoComponent.vue?vue&type=script&lang=js"
export * from "./SelectorAsientoComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectorAsientoComponent.vue?vue&type=style&index=0&id=623d6f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d6f5c",
  null
  
)

export default component.exports